import { motion } from 'framer-motion';
import { Eyebrow } from '../Reveal';

export const PageHead = ({ eyebrow, title, lede, accent = '#FBBF24', image, imageAlt = '', children }) => (
  <div className="relative pt-28 lg:pt-40 pb-10 lg:pb-16" data-testid="page-head">
    {image && (
      <div className="absolute left-1/2 -translate-x-1/2 w-screen -top-16 bottom-0 pointer-events-none overflow-hidden" data-testid="page-head-anchor">
        <motion.img initial={{ opacity: 0, scale: 1.08 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 2, ease: [0.22, 1, 0.36, 1] }} src={image} alt={imageAlt} className="absolute right-0 top-0 h-full w-full lg:w-[55%] object-cover opacity-45" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#02040a] via-[#02040a]/80 to-[#02040a]/20" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#02040a]/40 via-transparent to-[#02040a]" />
      </div>
    )}
    <div className="relative">
    <Eyebrow accent={accent}>{eyebrow}</Eyebrow>
    <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }} className="font-celestial text-4xl sm:text-5xl lg:text-6xl font-light text-slate-100 leading-[1.05] max-w-4xl" data-testid="page-title">
      {title}
    </motion.h1>
    {lede && <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.25 }} className="mt-7 text-base md:text-lg text-slate-400 leading-relaxed max-w-2xl" data-testid="page-lede">{lede}</motion.p>}
    {children}
    </div>
  </div>
);

export const Section = ({ id, children, className = '' }) => (
  <section id={id} className={`py-12 lg:py-20 ${className}`}>{children}</section>
);

export const Chip = ({ children, color = '#FBBF24', testId }) => (
  <span className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.25em] rounded-full border px-3 py-1" style={{ color, borderColor: `${color}55` }} data-testid={testId}>
    <span className="w-1.5 h-1.5 rounded-full animate-pulse-dot" style={{ background: color }} />{children}
  </span>
);
